import { useEffect, useState } from 'react';
import { getConfig, sb } from '../lib/supabase.js';
import { loadAll } from '../store/actions.js';
import { useApp } from '../store/ui.js';
import { nav } from './nav.js';
import { Sidebar, TopBar, TabBar } from './Layout.jsx';
import { ModalHost, Toast, LoadBar, setWhyOpener } from '../components/ui.jsx';
import { LoginScreen, SetupScreen, NewPasswordScreen } from '../features/auth/AuthScreens.jsx';
import { openWhyModal } from '../features/explain/WhySheet.jsx';
import { Dashboard } from '../features/dashboard/Dashboard.jsx';
import { Transactions } from '../features/transactions/Transactions.jsx';
import { AddPage } from '../features/add/AddPage.jsx';
import { FlowPage } from '../features/flow/FlowPage.jsx';
import { GoalsPage } from '../features/goals/GoalsPage.jsx';
import { SettingsPage } from '../features/settings/SettingsPage.jsx';
import { YearPage } from '../features/reports/YearPage.jsx';

setWhyOpener(openWhyModal);
let booted = false;
// הקישור מהמייל "שכחתי סיסמה" חוזר לאתר עם type=recovery
let recovery = /type=recovery/.test(location.hash);

const PAGES = { Dash: Dashboard, Tx: Transactions, Add: AddPage, Flow: FlowPage, Year: YearPage, Goals: GoalsPage, Set: SettingsPage };

export function App() {
  // setup: חסר חיבור ל-Supabase · login: צריך להתחבר · loading · ready · error
  const [phase, setPhase] = useState(() => (getConfig() ? 'loading' : 'setup'));

  async function start() {
    // מצב הדגמה, בפיתוח בלבד: http://localhost:5173/?demo טוען נתוני דוגמה בלי Supabase
    if (import.meta.env.DEV && new URLSearchParams(location.search).has('demo')) {
      const { loadDemo } = await import('./demo.js');
      await loadDemo();
      return setPhase('ready');
    }
    if (!getConfig()) return setPhase('setup');
    const { data } = await sb().auth.getSession();
    if (!data.session) return setPhase('login');
    if (recovery) { recovery = false; return setPhase('reset'); }
    setPhase('loading');
    try {
      await loadAll();
      setPhase('ready');
    } catch {
      setPhase('error');
    }
  }

  useEffect(() => {
    // StrictMode מריץ effect פעמיים בפיתוח. הטעינה צריכה לקרות פעם אחת
    if (!booted) { booted = true; start(); }
    if (!getConfig()) return undefined;
    const { data } = sb().auth.onAuthStateChange((ev) => { if (ev === 'SIGNED_OUT') setPhase('login'); });
    return () => data.subscription.unsubscribe();
  }, []);

  if (phase === 'setup') return <><SetupScreen onDone={start} /><Toast /></>;
  if (phase === 'reset') return <><NewPasswordScreen onDone={start} /><Toast /></>;
  if (phase === 'login') return <><LoginScreen onLogin={start} /><Toast /></>;
  if (phase === 'loading') return <><LoadBar /><div className="fullscreen"><span className="sp" style={{ color: 'var(--accent)', width: 30, height: 30 }} /></div></>;
  if (phase === 'error') return (
    <div className="fullscreen"><div className="box" style={{ textAlign: 'center' }}>
      <h2>⚠️ הטעינה נכשלה</h2>
      <p className="box-sub">בדוק את החיבור לאינטרנט ונסה שוב.</p>
      <button className="ubtn ubtn-primary w100" onClick={start}>נסה שוב</button>
    </div><Toast /></div>
  );
  return <Shell />;
}

function Shell() {
  useApp();
  const Page = PAGES[nav.page] || Dashboard;
  return (
    <>
      <LoadBar />
      <div className="shell">
        <Sidebar />
        <div className="main-col">
          <TopBar />
          <main className="content" key={nav.page}>
            <Page />
          </main>
        </div>
      </div>
      <TabBar />
      <ModalHost />
      <Toast />
    </>
  );
}
